<template>
  <main class="search-container search-results w-full max-w-full px-2">
    <section class="not-empty-search-results hidden">
      <h1 class="w-full search-results__search-term header--lg my-3" qaid="search-term">
        {{ $t(`search.page.searchText`, [searchTerm]) }}
      </h1>
      <!-- CMS default components -->
      <slot v-bind="{toggleFiltersState, viewBreakpointLessThan, viewBreakpointMoreThan, areFiltersVisible}"></slot>
      <section class="empty-search-results"></section>
    </section>
  </main>
</template>

<script>
import {mapActions, mapMutations, mapState, mapGetters} from 'vuex';
import {PdlTabs, PdlTabPane} from '@pedal/pdl-tabs';
import SearchContentListItem from '@/components/search/SearchContentListItem.vue';

export default {
  name: 'SearchContainer',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    PdlTabs,
    // eslint-disable-next-line vue/no-unused-components
    PdlTabPane,
    // eslint-disable-next-line vue/no-unused-components
    SearchContentListItem,
  },
  props: {
    searchTerm: {
      type: String,
      default: '',
    },
    isArchiveEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('viewSize', ['viewBreakpointLessThan', 'viewBreakpointMoreThan']),
    ...mapState('plp', ['areFiltersVisible']),
  },

  mounted() {
    this.updateLastPlp();
  },
  methods: {
    ...mapActions('storage', ['updateLastPlp']),
    ...mapMutations('plp', ['setAreFiltersVisible']),
    toggleFiltersState() {
      this.setAreFiltersVisible(!this.areFiltersVisible);
    },
  },
};
</script>
